/**
 * Mod: sms
 * Time: 2021-07-21 09:46:30
 */

import request from '@/sdk/fetch'
/**
 * 手机验证码(防水墙)
 * @param phone 手机
 * @param ticket ticket
 * @param randstr 随机串
 */
export function apiSmsCode(data = {}) {
  return request.post('/sms/code', data)
}
